export interface Language {
  value: string;
  label: string;
}

export const LANGUAGES: Language[] = [
  { value: "af_ZA", label: "Afrikaans" },
  { value: "sq_AL", label: "Shqip" },
  { value: "ar_AR", label: "العربية" },
  { value: "ar_SA", label: "العربية (المملكة العربية السعودية)" },
  { value: "hy_AM", label: "Հայերեն" },
  { value: "ay_BO", label: "Aymar aru" },
  { value: "az_AZ", label: "Azərbaycan dili" },
  { value: "eu_ES", label: "Euskara" },
  { value: "bn_IN", label: "Bangla" },
  { value: "bs_BA", label: "Bosanski" },
  { value: "bg_BG", label: "Български" },
  { value: "my_MM", label: "မြန်မာဘာသာ" },
  { value: "ca_ES", label: "Català" },
  { value: "ck_US", label: "Cherokee" },
  { value: "hr_HR", label: "Hrvatski" },
  { value: "cs_CZ", label: "Čeština" },
  { value: "da_DK", label: "Dansk" },
  { value: "nl_NL", label: "Nederlands" },
  { value: "nl_BE", label: "Nederlands (België)" },
  { value: "en_IN", label: "English (India)" },
  { value: "en_GB", label: "English (UK)" },
  { value: "en_US", label: "English (US)" },
  { value: "et_EE", label: "Eesti" },
  { value: "fo_FO", label: "Føroyskt" },
  { value: "tl_PH", label: "Filipino" },
  { value: "fi_FI", label: "Suomi" },
  { value: "fr_CA", label: "Français (Canada)" },
  { value: "fr_FR", label: "Français (France)" },
  { value: "fy_NL", label: "Frysk" },
  { value: "gl_ES", label: "Galego" },
  { value: "ka_GE", label: "ქართული" },
  { value: "de_DE", label: "Deutsch" },
  { value: "el_GR", label: "Ελληνικά" },
  { value: "gn_PY", label: "Avañe'ẽ" },
  { value: "gu_IN", label: "ગુજરાતી" },
  { value: "ht_HT", label: "Ayisyen" },
  { value: "he_IL", label: "‏עברית‏" },
  { value: "hi_IN", label: "हिन्दी" },
  { value: "hu_HU", label: "Magyar" },
  { value: "is_IS", label: "Íslenska" },
  { value: "id_ID", label: "Bahasa Indonesia" },
  { value: "ga_IE", label: "Gaeilge" },
  { value: "it_IT", label: "Italiano" },
  { value: "ja_JP", label: "日本語" },
  { value: "jv_ID", label: "Basa Jawa" },
  { value: "kn_IN", label: "Kannaḍa" },
  { value: "kk_KZ", label: "Қазақша" },
  { value: "km_KH", label: "Khmer" },
  { value: "ko_KR", label: "한국어" },
  { value: "ku_TR", label: "Kurdî" },
  { value: "lv_LV", label: "Latviešu" },
  { value: "li_NL", label: "Lèmbörgs" },
  { value: "lt_LT", label: "Lietuvių" },
  { value: "mk_MK", label: "Македонски" },
  { value: "mg_MG", label: "Malagasy" },
  { value: "ms_MY", label: "Bahasa Melayu" },
  { value: "ml_IN", label: "Malayāḷam" },
  { value: "mt_MT", label: "Malti" },
  { value: "mr_IN", label: "मराठी" },
  { value: "mn_MN", label: "Монгол" },
  { value: "ne_NP", label: "नेपाली" },
  { value: "se_NO", label: "Davvisámegiella" },
  { value: "nb_NO", label: "Norsk (bokmål)" },
  { value: "nn_NO", label: "Norsk (nynorsk)" },
  { value: "ps_AF", label: "پښتو" },
  { value: "fa_IR", label: "فارسی" },
  { value: "pl_PL", label: "Polski" },
  { value: "pt_BR", label: "Português (Brasil)" },
  { value: "pt_PT", label: "Português (Portugal)" },
  { value: "pa_IN", label: "ਪੰਜਾਬੀ" },
  { value: "qu_PE", label: "Qhichwa" },
  { value: "ro_RO", label: "Română" },
  { value: "rm_CH", label: "Rumantsch" },
  { value: "ru_RU", label: "Русский" },
  { value: "sa_IN", label: "संस्कृतम्" },
  { value: "sr_RS", label: "Српски" },
  { value: "zh_CN", label: "中文(简体)" },
  { value: "sk_SK", label: "Slovenčina" },
  { value: "sl_SI", label: "Slovenščina" },
  { value: "so_SO", label: "Soomaaliga" },
  { value: "es_LA", label: "Español" },
  { value: "es_CL", label: "Español (Chile)" },
  { value: "es_CO", label: "Español (Colombia)" },
  { value: "es_MX", label: "Español (México)" },
  { value: "es_ES", label: "Español (España)" },
  { value: "es_VE", label: "Español (Venezuela)" },
  { value: "sw_KE", label: "Kiswahili" },
  { value: "sv_SE", label: "Svenska" },
  { value: "sy_SY", label: "Leššānā Suryāyā" },
  { value: "tg_TJ", label: "тоҷикӣ, تاجیکی‎, tojikī" },
  { value: "ta_IN", label: "தமிழ்" },
  { value: "tt_RU", label: "татарча / Tatarça / تاتارچا" },
  { value: "te_IN", label: "Telugu" },
  { value: "th_TH", label: "ภาษาไทย" },
  { value: "zh_HK", label: "中文(香港)" },
  { value: "zh_TW", label: "中文 (繁體)" },
  { value: "tr_TR", label: "Türkçe" },
  { value: "uk_UA", label: "Українська" },
  { value: "ur_PK", label: "اردو" },
  { value: "uz_UZ", label: "O'zbek" },
  { value: "vi_VN", label: "Tiếng Việt" },
  { value: "cy_GB", label: "Cymraeg" },
  { value: "xh_ZA", label: "isiXhosa" },
  { value: "yi_DE", label: "ייִדיש" },
  { value: "zu_ZA", label: "isiZulu" }
];

// Helper function to get language label from value
export const getLanguageLabel = (value?: string | null): string => {
  if (!value) return "";
  const language = LANGUAGES.find(lang => lang.value === value);
  return language ? language.label : value;
};